// esbuild doesn't bundle moment's dynamically required locales, so load the ones Eagle uses explicitly
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/nl';

// Importing a locale file makes it the global default; keep moment's default ('en') as before
moment.locale('en');
